export const SAVE_ALL_ACCESSORIES = 'SAVE_ALL_ACCESSORIES'
export const SAVE_ACCESSORY = 'SAVE_ACCESSORY'
